@if (getPatientRecordPage()) {
  <a class="virtualcenter-link" [routerLink]="getPatientRecordPage()">
    {{ getPatientName() }}
  </a>
} @else {
  <span>{{ getPatientName() }}</span>
}
